export default __webpack_public_path__ + "logo.937a03ab2952de8a3b9711da45b463ce.png";